import React from "react";
import { Box } from "@chakra-ui/react";
import SandboxExample from "../sandbox/SandboxExample";

const SandboxPageExample = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Box flex="1" zIndex={1}>
                <SandboxExample />
            </Box>
        </Box>
    );
};

export default SandboxPageExample;